import { Radio, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { OPTIONS_LABEL } from '../../utils/constants';
import palette from '../../theme/palette';
import Modal from '../common/Modal';

const useStyle = makeStyles({
  titleText: {
    fontSize: 18
  },
  subText: {
    fontSize: 16,
    color: palette.grey[400]
  }
});

function OptionRadioButtons({ qusData, updateArray, qusIndex }) {
  const [options, setOptions] = useState(qusData.options);
  const handleAnsChange = (index) => {
    const newOpnData = [...options];
    for (let i = 0; i < newOpnData.length; i += 1) {
      const element = newOpnData[i];
      if (i === index) {
        element.isAnswer = true;
      } else {
        element.isAnswer = false;
      }
    }
    setOptions(newOpnData);
    updateArray({
      _id: qusData._id,
      options: newOpnData
    });
  };
  return (
    <TableRow key={qusIndex}>
      <TableCell>{qusIndex + 1}</TableCell>
      {options.map((qo, i) => (
        <TableCell align="center" key={qo.id}>
          <Radio checked={qo.isAnswer} onChange={() => handleAnsChange(i)} />
        </TableCell>
      ))}
    </TableRow>
  );
}

OptionRadioButtons.propTypes = {
  qusData: PropTypes.shape({
    _id: PropTypes.string,
    options: PropTypes.array
  }),
  updateArray: PropTypes.func,
  qusIndex: PropTypes.number
};

export default function OMRDialog({
  isOpen,
  questionsArray,
  onClose,
  numOfAns = 0,
  updateQuestionArray
}) {
  const classes = useStyle();
  const handleClose = () => {
    onClose();
  };

  const updateArrayWithAns = (qusObj) => {
    const dumQusArr = [...questionsArray];
    const findQusIndex = dumQusArr.findIndex((qa) => qa._id === qusObj._id);
    if (findQusIndex > -1) {
      dumQusArr[findQusIndex].options = qusObj.options;
    }
    updateQuestionArray(dumQusArr);
  };

  const renderHead = () => {
    const renderData = [];
    renderData.push(<TableCell />);
    for (let i = 0; i < numOfAns; i += 1) {
      renderData.push(
        <TableCell align="center" key={i}>
          {OPTIONS_LABEL[i]}
        </TableCell>
      );
    }
    return renderData;
  };
  return (
    <Modal
      open={isOpen}
      title={
        <>
          <p className={classes.titleText}>Mark correct answers here.</p>
          <p className={classes.subText}>Students will see a blank OMR sheet</p>
        </>
      }
      onClose={() => handleClose()}
    >
      <Table>
        <TableHead>
          <TableRow>{renderHead()}</TableRow>
        </TableHead>
        <TableBody>
          {questionsArray.map((qa, i) => (
            <OptionRadioButtons
              key={i}
              qusIndex={i}
              qusData={qa}
              updateArray={updateArrayWithAns}
            />
          ))}
        </TableBody>
      </Table>
    </Modal>
  );
}

OMRDialog.propTypes = {
  isOpen: PropTypes.bool,
  questionsArray: PropTypes.array,
  onClose: PropTypes.func,
  numOfAns: PropTypes.number,
  updateQuestionArray: PropTypes.func
};
